export enum MediaFileType {

  ORG_LOGO = 'ORG_LOGO',
  INVOICE = 'INVOICE',
  COST_ESTIMATE = 'COST_ESTIMATE',
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  PREVIEW = 'PREVIEW',
  PROFORMA_INVOICE = 'PROFORMA_INVOICE',
  CANCELLATION = 'CANCELLATION',
  RECEIPT = 'RECEIPT',
  DATEV_EXPORT = 'DATEV_EXPORT',
  CSV_EXPORT = 'CSV_EXPORT',
  IRON_BACKUP = 'IRON_BACKUP',
  CONTACT_VEHICLE_INSPECTION_NOTIFICATION = 'CONTACT_VEHICLE_INSPECTION_NOTIFICATION',
  CONTACT_VEHICLE_TIRE_CHANGE_NOTIFICATION = 'CONTACT_VEHICLE_TIRE_CHANGE_NOTIFICATION',
  CONTACT_PRINTOUT = 'CONTACT_PRINTOUT',
  VEHICLE_PRINTOUT = 'VEHICLE_PRINTOUT',
  SHEET = 'SHEET',
  SHEET_PREVIEW = 'SHEET_PREVIEW',
  // A file that has been uploaded (media upload) is assigned via "belong".
  UPLOAD = 'UPLOAD',
  // Only Frontend / Special
  UNKNOWN = 'UNKNOWN',
}
